import { FlexLayout } from '@deity/falcon-ui';
import DashboardBlock from 'components/Packages/PackagePopout/DashboardBlock';
import type { FC } from 'react';
import type { PackageVersionContentInfo } from 'services/graphql/generated/schemas';

type DashboardBlocksProps = {
  versionUrl: string;
  versionInfo: PackageVersionContentInfo | undefined;
};
const DashboardBlocks: FC<DashboardBlocksProps> = ({ versionUrl, versionInfo }) => (
  <FlexLayout p="xxl" justifyContent="center">
    <DashboardBlock
      itemsInversion={versionInfo?.webServices}
      itemTitle="Services"
      to={`${versionUrl}/services`}
      icon="openWith"
    />
    <DashboardBlock
      itemsInversion={versionInfo?.models}
      itemTitle="Structures"
      to={`${versionUrl}/structures`}
      icon="ballot"
    />
    <DashboardBlock
      itemsInversion={versionInfo?.mappings}
      itemTitle="Mappings"
      to={`${versionUrl}/mappings`}
      icon="accountTree"
    />
    <DashboardBlock
      itemsInversion={versionInfo?.flows}
      itemTitle="Flows"
      to={`${versionUrl}/flows`}
      icon="playCircle"
    />
  </FlexLayout>
);

export default DashboardBlocks;
